import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    wrapper: {
      position: 'relative',
    },
    avatarBtn: {
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: CornerRadius.circle,
      '& *': {
        cursor: 'pointer',
      },
    },
    menuPanel: {
      display: 'flex',
      flexDirection: 'column',
    },
    sheetHeading: {
      padding: [Spacings.s0, Spacings.s16, Spacings.s8, Spacings.s16],
    },
  },
  { name: 'UserMenuButton' }
);

export default useStyles;
